// 导入请求数据的 request 模块
import request from '@/utils/request'

// 根据省份查询项目信息
export const selectProject = (province, currentPage, pageSize) => {
  return request.get('/project/select', {
    params: {
      province: province,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据公司名称查询项目信息
export const SelectProjectCompany = (company, currentPage, pageSize) => {
  return request.get('/project/select/company', {
    params: {
      company: company,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据招聘名称查询项目信息
export const SelectProjectName = (name, currentPage, pageSize) => {
  return request.get('/project/select/name', {
    params: {
      name: name,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据文件id下载文件
export const filesDownloadByIdProject = (id) => {
  return request.post('/project/select/id', id, {
    params: {
      id
    },
    responseType: 'blob'
  })
}
